import { FC, SelectHTMLAttributes, useState, useEffect } from "react";
import { useForm } from "../../app/useForm";

import { Cases } from "../../types";

type SelectAttrs = SelectHTMLAttributes<HTMLSelectElement>;
type SelectProps = SelectAttrs & {
  cases: Cases;
};

export const Select: FC<SelectProps> = ({ cases, ...args }) => {
  const { value, name } = { ...args };
  const [newValue, setNewValue] = useState(value);
  const { handleFieldChange } = useForm();

  useEffect(() => {
    setNewValue(value);
  }, [value]);
  return (
    <select
      {...args}
      value={cases ? cases.find((x) => x.value === newValue)?.name : newValue}
      onChange={(e) => {
        handleFieldChange(name, e.target.value);
        setNewValue(e.target.value);
      }}
      className="h-10 w-full rounded-md border border-stone-300 pl-3 text-stone-900 placeholder-stone-400 focus:border-stone-500 focus:ring-stone-500 dark:border-stone-900 dark:bg-stone-700 dark:text-stone-100 dark:placeholder-stone-400 sm:text-sm"
    >
      {cases?.map((o) => {
        const value = o.value.toString();
        return (
          <option key={o.name} value={o.name}>
            {value}
          </option>
        );
      })}
    </select>
  );
};
